import moment from "moment";
import { SBDatePicker } from "../../UiComponents/SBDatePicker";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { TopBar } from "../../shared/topBar/TopBar";
import { SBADropDown, SBAComboBox } from "../../UiComponents/SBADropDown";
import { getPortFolioCreditFacilityAction } from "../../actions/portfolioAction";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTransactionStatusAction } from "../../actions/transactionAction";
import {  useParams ,useNavigate} from "react-router";
import { sbaAxios } from "../../utils/sbaAxios";
import { insertUpdateTransactionAPI,getPortfolioDetailAPI, getPortfolioListAPI, getPortfolioLedgerAccountsAPI} from "../../../config/apiConfig";
import { SBNotify } from "../../utils/sbNotify";
import { UrlPath } from "../../../config/routeConfig";
import { ToastContainer } from "react-toastify";
import { currencyFormatter, getTransactionByID,getPortfolioListByAssetAndTransType,gettransactionEditAccess,gettransactionAddAccess } from "../utils";
import { deleteTransaction } from "../../../config/apiConfig";
import { SBACurrencyInput } from "../../UiComponents/SBACurrencyInput";

export const JournalEntry = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const history = useNavigate();

  const Level = params.ObjectType==1 ? [
    {
      BreadCrumb: "Transactions >",
      Routes: `${UrlPath.Transactions}${params.EntityId}`,
    },
    {
      BreadCrumb: "Journal Entry",
      Routes: `${UrlPath.AssetJournalEntry}${params.EntityId}`,
    },
  ] :
      [
    {
      BreadCrumb: "Transactions >",
      Routes: `/${UrlPath.portfolioTransaction}${params.EntityId}`,
    },
    {
      BreadCrumb: "Journal Entry",
      Routes: `/${UrlPath.PortfolioJournalEntry}${params.EntityId}/${params.ObjectType}`,
    },
  ] ;


  const Gstate = useSelector((state) => state);
  const Account = Gstate.portfolio.creditFacility || [];
  const statusStore = Gstate.transaction.statusList || [];


  const transactionId=parseInt(params?.TransId);
  const objType=parseInt(params?.ObjectType);

  const [portfolioList,setPortfolioList]=useState([]);
  const [statusDS, setStatusDS] = useState(statusStore);
  const [portfolio,setPortfolio]=useState();
  const [transactionData, setTransactionData] = useState(plainJournalEntry);
  const [existingChild,setExistingChild]=useState([]);
  const [accountList, setAccountList]=useState([]);
  const[transactionEditAccess,setTransactionEditAccess]=useState(false);
  const[transactionaddAccess,setTransactionAddAccess]=useState(false);
  const statusVal =  { "TransStatus": transactionData.TradeStatusName, "TransStatusId": transactionData.TradeStatusId };
  const portfolioVal =  { "PortfolioId": transactionData.PortfolioId, "PortfolioName": transactionData.PortfolioName } 
  const JournalEntryChildTrans=transactionData.ChildDetails.map(ct=>{
    const Debit=ct.TransAmount >= 0 ?  ct.TransAmount : 0;
    const Credit=ct.TransAmount <= 0 ?  ct.TransAmount : 0;
    return {
    ...ct,
    Debit,
    Credit
  }});


const TotalDebit=JournalEntryChildTrans.map(child=>child.Debit).reduce((acc, current) => acc + current, 0);
  const TotalCredit=JournalEntryChildTrans.map(child=>child.Credit).reduce((acc, current) => acc + current, 0);
  const outOfBalance=parseFloat(TotalCredit+TotalDebit);
  useEffect(() => {
    document.title='Transaction Journal Entry'
    setTransactionAddUserAccess();
    setTransactionEditUserAccess();
    dispatch(getPortFolioCreditFacilityAction());
    dispatch(getTransactionStatusAction());
    setTransactionByID(transactionId);
   
    if (params.ObjectType == 1) {
      setPortfolioByAssetId(params?.EntityId);
    } 
    else if (params.ObjectType == 3) {
      setPortfolioByID(params?.EntityId);
      getAccountList(params?.EntityId);
    };

  }, []);

  useEffect(() => {
    setStatusDS(statusStore);
  }, [statusStore]);

   // User Access Rights
   const setTransactionEditUserAccess= async()=>
   {
       const access = await gettransactionEditAccess();
       setTransactionEditAccess(access);
   }
   const setTransactionAddUserAccess= async()=>
   {
       const access = await gettransactionAddAccess();
       setTransactionAddAccess(access);
   }
  const getAccountList=async(id)=>{
    if(id>0)
    try {
      const list=await getPortfolioLedgerAccounts(id);
      setAccountList(list);
    }
    catch{
      setAccountList([]);
    }
    else{
      setAccountList([]);
    }
  }
  const setPortfolioByID=async(Id)=>{
    try{
      const portfolio=await getPortfolioDetailsByID(Id);
      setTransactionData(value=>({...value,PortfolioId:portfolio?.PortfolioId,PortfolioName:portfolio?.PortfolioName}));
      setPortfolio(portfolio);
      
    }
    catch (e){
      setTransactionData(value=>({...value,PortfolioId:0,PortfolioName:''}));
      setPortfolio({});
    }
   
  }; 
  const setTransactionByID=async(id)=>{
    if(id>0)
    {
      try {
        const details=await getTransactionByID(id);
        setTransactionData(details);
        setPortfolioByID(details.PortfolioId);
      }catch (e){
        setTransactionData(plainJournalEntry);
      }
    }
    else {
      setTransactionData(plainJournalEntry);
    }
  };
  const portfolioFilterChange=(e)=>{
    const terms=e.filter.value;
    if(terms.length>1)
    {
      setPortfolioByTerm(terms);  
    }
  };
  const setPortfolioByTerm=async(term)=>{
    try{
      const portfolioList=await getPortfolioListByTerms(term);
      setPortfolioList(portfolioList);
    }
    catch (e){
      console.log(e,'Error Fetching the data for portfolio');
      setPortfolioList([]);
    }
  };
  const transactiondateChange = (e) => {
    const date= e.toISOString();
    if(e)
    {
      setTransactionData(value => ({ ...value, TransDate:date}));
    }
  };
  const statusChange = (e) => {
    if (e.value) {
      setTransactionData(value => ({ ...value, TradeStatusId: e.value.TransStatusId , TradeStatusName:e.value.TransStatus}));
    }
  };
  const portfolioChange = (e) => {
    if (e.value) {
      setTransactionData(value => ({ ...value, PortfolioId: e.value.PortfolioId , PortfolioName:e.value.PortfolioName}));
      setPortfolioByID(e.value.PortfolioId);
      getAccountList(e.value.PortfolioId);
      const updatedchild=transactionData.ChildDetails.map(item=>({...item,AssetId:0,AssetName:''}));
      setTransactionData(value=>({...value,ChildDetails:updatedchild}));
     if(params.ObjectType===3)
      history(`/${UrlPath.PortfolioJournalEntry}${transactionId}/${e.value.PortfolioId}/3`);
    }
  };

  const setPortfolioByAssetId = async (Id) => {
      
    try {
      const portfolio = await getPortfolioListByAssetAndTransType(Id,23);
    const  portfolios= portfolio.map((item) => ({
        'PortfolioName':item.Name,
        'PortfolioId':item.PortfolioId
    }))
      setPortfolioList([]);
      if(portfolios.length>0)
      {
      setTransactionData(value => ({ ...value, "PortfolioName": portfolios[0]?.PortfolioName, "PortfolioId": portfolios[0]?.PortfolioId }));
    setPortfolioByID(portfolios[0]?.PortfolioId);
      }
    }
    catch (e) {
      setTransactionData(value => ({ ...value, PortfolioId: 0, PortfolioName: '' }));
      setPortfolioList({});
    }
  }
  const saveJournalEntry = () => {
    let transAmt=0;
    let isValid=true;
    const transDate=transactionData.TransDate;
    const balance= parseFloat(currencyFormatter(outOfBalance,2 )); 
    const childTrans = transactionData?.ChildDetails?.map(childTrans => {
      if (!childTrans?.AssetId)
        isValid = false;
      transAmt += getPositive(childTrans.TransAmount);
      return {
        transId: childTrans?.TransId,
        assetId: childTrans?.AssetId,
        TransTypeId: 15,
        transDate: new Date().toISOString(),
        transAmount: childTrans?.TransAmount,
        localAmount: parseFloat((childTrans?.TransAmount * transactionData.ExchangeRate).toFixed(2)),
        transDescription: childTrans?.TransDescription
      }
    });
    // validation
    if (!transactionData.PortfolioId)
    {
      SBNotify({ Msg: "Please Select a Portfolio", type: "error" });
      isValid=false;
      return;
    };
    if(!transDate)
    {
      SBNotify({ Msg: "Please Select a Transaction Date", type: "error" });
      isValid=false;
      return;
    }
    const updatedChildTransaction=[...childTrans,...existingChild.filter(item=>item.TransId!==0)].map(item=>({...item,transDate:transactionData.TransDate}))
    const DS = {
      transId: transactionData?.TransId || 0,
      portfolioId: transactionData.PortfolioId || 0,
      assetId: 0,
      shareClassId: 0,
      assetLotId: 0,
      accountIdToBalance:null,
      tradeStatusId: transactionData.TradeStatusId,
      transTypeId: 15,
      transDate: transactionData.TransDate,
      transAmount: parseFloat((transAmt/2).toFixed(2)),
      localAmount: parseFloat((transAmt/2).toFixed(2)*transactionData.ExchangeRate),
      exchangeRateId: 0,
      exchangeRate: transactionData.ExchangeRate,
      allocationDate: null,
      shares: 0,
      nav: 0,
      transDescription: transactionData.TransDescription,
      isFullRedemption: false,
      isInsurance: false,
      isFee: false,
      isCommitmentRelease: false,
      modifiedBy: 0,
      childTrans: updatedChildTransaction,
    };
    if(balance!==0 )
    {
      showError("Debits & Credits are out of balance");
      return;
    }
    if(transAmt===0 || childTrans.some(item=>item.transAmount===0) )
    {
      showError("Debit or Credit is required");
      return;
    }
   
    if (isValid){
      sbaAxios({ url: insertUpdateTransactionAPI, method: "post", data: DS })
        .then((res) => {
          setTimeout(() => {
           DS.transId!=0 ?  SBNotify({ Msg: 'Journal Entry Details Updated Successfully' }) : SBNotify({ Msg: 'Journal Entry Details Added Successfully' });
          }, 500);
          navigateBack();
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      SBNotify({ Msg: "Please Enter All the Required Fields", type: "error" });
    }
  };
  const showError=(msg)=>{
    SBNotify({ Msg: msg, type: "error" });
  }
  const navigateBack = () => {
    if(objType===1)
    history(`${UrlPath.Transactions}${params?.EntityId}`);
    if(objType===3)
    history(`/${UrlPath.portfolioTransaction}${transactionData.PortfolioId}`);
  };
  const addChildTransaction=()=>{
    const preChild=transactionData.ChildDetails || [];
    const plainChildTrans = {
      "TransId": 0,
      "TransTypeId": 15,
      "TransTypeName": "Journal Entry",
      "AssetId": 0,
      "AssetName": "",
      "ShareclassId": 0,
      "ShareClassName": "",
      "AssetLotId": 0,
      "AssetLotName": "",
      "TransDate": "",
      "TransAmount": 0,
      "TransDescription": "",
      "ModifiedById": 0,
      "ModifiedByName": ""
    };
    // sbaAxios({url})
    setTransactionData(value=>({
      ...value,
      ChildDetails:[...preChild,plainChildTrans]
    }))
  };
  const removeChildTrans=(index)=>{
    if(transactionData?.ChildDetails.length>2)
    {
      const updatedTransChild=transactionData?.ChildDetails.filter((item,ChildIndex)=>ChildIndex!==index)
      const deletedChildTrans=transactionData?.ChildDetails.find((item,ChildIndex)=>ChildIndex===index);
      deletedChildTrans.TransAmount=0;
      setExistingChild(val=>[...val,deletedChildTrans]);
      setTransactionData(value=>({...value,ChildDetails:updatedTransChild}));
    }
    else
    {
      SBNotify({Msg:"Atleast Two Child Transaction Required" ,type:"error"});
    }
  };
  const UpdateChildTrans=(index,values,type)=>{
    const formattedVal= values || null;
    const value=type=='Credit' ? formattedVal * -1 || null : formattedVal ;
    const updatedTransChild=transactionData?.ChildDetails?.map((item,ind)=>{
    if(ind===index)
    return {
      ...item,
      TransAmount:parseFloat(value)  || 0,
    }
    else 
    return item
    });
    setTransactionData(value=>({...value,ChildDetails:updatedTransChild}))
  };
  const updateAccount=(index,e)=>{
    if(e.value)
    {
      const value=e.value;
      const updatedTransChild=transactionData?.ChildDetails?.map((item,ind)=>{
        if(ind===index)
        return {
          ...item,
          AssetName:value.AssetName,
          AssetId:value.AssetId
        }
        else 
        return item
        })
        setTransactionData(value=>({...value,ChildDetails:updatedTransChild}))
    }
  };
  const updateDescription=(index,e)=>{
    const value=e.target.value;
      const updatedTransChild=transactionData?.ChildDetails?.map((item,ind)=>{
        if(ind===index)
        return {
          ...item,
          TransDescription:value
        }
        else 
        return item
        })
        setTransactionData(value=>({...value,ChildDetails:updatedTransChild}))
  };
  const updateExchangeRate=(e)=>{
    const value=parseFloat(e) || 0;
    setTransactionData(trans=>({...trans,ExchangeRate:value}));
  };
  return (
    <>
      <TopBar label={"Journal Entry"} />
      <div className="mainContentData">
        <BreadCrumbs Levels={Level} />
        <div className="container-fluid">
          <div className="p-3">
            <div className="row">
              <div className="col-md-4">
                <div className="mb-4">
                  <label className="mb-1 label">Status</label>
                  <div>
                    <div>
                      <SBADropDown
                        className="w-75"
                        data={statusDS}
                        textField={"TransStatus"}
                        valueField={"TransStatusId"}
                        value={statusVal}
                        onChange={statusChange}
                      />
                    </div>
                  </div>
                </div>  
                <div className="mb-4">
                  <label className="mb-1 label">Transaction Date</label>
                  <div>
                    <SBDatePicker
                      className="w-75"
                      value={moment (transactionData?.TransDate) }
                      onChange={(e)=>{transactiondateChange(e)}}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="mb-4">
                  <label className="mb-1 label">Portfolio</label>

                  <div>
                    <SBAComboBox
                      className="w-75"
                      data={portfolioList}
                      textField={"PortfolioName"}
                      valueField={"PortfolioId"}
                      value={portfolioVal}
                      onChange={portfolioChange}
                      onFilterChange={portfolioFilterChange}
                      disabled={transactionId!==0}
                    />
                  </div>
                </div>
              </div>
              <div className="mb-4 row">
                <div className="col-md-12 d-flex mt-4 justify-content-end">
                {!transactionaddAccess?<></>:
                  <button
                    type="button"
                    className="p-sm-btn mx-1 my-3"
                    onClick={()=>{addChildTransaction()}}
                  >
                    <i className="fa-solid fa-plus" />
                    Add
                  </button>
}
                </div>
                  <div class="form-group">
                    <div class="col-sm-12">
                      <div className="scrollable-table" style={{ height: "400px" ,overflowY:'scroll' }}>
                        <table
                          class="table table-striped"
                          id="JournalentryTable"
                          border="1" 
                        >
                          <thead style={{position:'sticky' , top:'0'}}>
                            <tr>
                              <th><label className="">Account</label></th>
                              <th>Description</th>
                              <th>Debit ({portfolio?.CurrencyCode})</th>
                              <th>Credit ({portfolio?.CurrencyCode})</th>
                              <th>Exchange Rate</th>
                              <th>Local Amount ({portfolio?.CurrencyCode}) </th>
                              <th>Delete</th>
                            </tr>
                          </thead>
                          <tbody>
                            {JournalEntryChildTrans?.map((item, childIndex) => (
                              <tr key={childIndex}>
                                <td
                                  key={childIndex + "Account"}
                                  style={{maxWidth:'400px', minWidth:'400px'}}
                                >
                                  <SBADropDown
                                    className="w-100"
                                    data={accountList}
                                    textField={"AssetName"}
                                    valueField={"AssetId"}
                                    value={{AssetId:item?.AssetId,AssetName:item?.AssetName}}
                                    onChange={(e)=>{updateAccount(childIndex,e)}}
                                  ></SBADropDown>
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    key={childIndex + "text1"}
                                    className="form-control"
                                    value={item?.TransDescription}
                                    onChange={(e)=>{updateDescription(childIndex,e)}}
                                  />
                                </td>
                                <td>
                                  <SBACurrencyInput
                                    key={childIndex + "text2"}
                                    decimalsLimit={2}
                                    value={(item?.Debit ).toFixed(2)}
                                    onBlur={(e)=>{
                                      const values=parseFloat(e);  UpdateChildTrans(childIndex,values,'Debit')}}
                                    // onValueChange={(values)=>{UpdateChildTrans(childIndex,values,'Debit')}}
                                  />
                                </td>
                                <td>
                                  <SBACurrencyInput
                                    key={childIndex + "text3"}
                                    decimalsLimit={2}
                                    value={(item?.Credit *-1).toFixed(2)}
                                    onBlur={(e)=>{const values=parseFloat(e);  UpdateChildTrans(childIndex,values,'Credit')}}
                                    // onValueChange={(values)=>{UpdateChildTrans(childIndex,values,'Credit')}}
                                  
                                  />
                                </td>
                                <td>
                                  <SBACurrencyInput
                                    key={childIndex + "text4"}
                                    id={"TxtExchangeRate_" + childIndex + ""}
                                    value={(transactionData.ExchangeRate).toFixed(2)}
                                    onBlur={(e)=>{updateExchangeRate(e)}}
                                    disableGroupSeparators={true}
                                    // disabled={true}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    key={childIndex + "text5"}
                                    className="form-control"
                                    disabled={true}
                                    value={(getPositive(item.TransAmount)*transactionData.ExchangeRate).toFixed(2)}
                                  />
                                </td>
                                <td>
                                  <i
                                    class="fa fa-times"
                                    id={`${childIndex}-delete`}
                                    style={{
                                      margin: "0% 8px 8px",
                                      color: "red",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => removeChildTrans(childIndex)}
                                  ></i>
                                </td>
                              </tr>
                            ))}
                            <tr>
                              <td>{}</td>
                              <td>Total</td>
                              <td>{currencyFormatter(Math.abs(TotalDebit *-1,2))}</td>
                              <td>{currencyFormatter(Math.abs(TotalCredit,2))}</td>
                              <td ></td>
                              <td ></td>
                              <td ></td>
                            </tr>
                            <tr>
                              <td>{}</td>
                              <td >Out of Balance</td>
                              <td >{outOfBalance<0 ? currencyFormatter(outOfBalance*-1,2 ) : ''}</td>
                              <td>{outOfBalance>=0 ? currencyFormatter(outOfBalance,2 ) : ''}</td>
                              <td ></td>
                              <td ></td>
                              <td ></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row m-0">
                <label className="mb-1 label">Description</label>
                  <textarea
                    className="form-control w-75"
                    type="text"
                    value={transactionData.TransDescription}
                    onChange={(e) => { setTransactionData(val => ({ ...val, TransDescription: e?.target?.value })) }}
                  />
            </div>
            <div className="m-3 d-flex justify-content-end" >
              <button className="s-sm-btn" onClick={() => {navigateBack()}}>
                Cancel
              </button>
             
                          {transactionId !== 0 ? (
                              <button className="ms-2 p-sm-btn" disabled={!transactionEditAccess || transactionData.IsLocked} onClick={() => { saveJournalEntry() }} >Save</button>

                          ) : (<button className="ms-2 p-sm-btn" disabled={false} onClick={() => { saveJournalEntry() }} >Save</button>
                          )
                          }
            </div>
          </div>
        </div>
      </div>
      <ToastContainer/>
    </>
  );
};

const getPortfolioListByTerms=async(term)=>{
  try {
    const response = await sbaAxios({url:getPortfolioListAPI+'?searchText='+term});
    return response;
  } 
  catch(e)  {
    return [];
  } 
};
const getPortfolioDetailsByID=async(portfolioId)=>{
  try {
    const response = await sbaAxios({url:getPortfolioDetailAPI+portfolioId});
    return response;
  } 
  catch(e)  {
    console.log(e,'Error Fetching the portfolio details')
    return {};
  };
};

var date = new Date();
var TransactionDate = new Date(date.getFullYear(), date.getMonth() + 1, 1);
const plainJournalEntry={
  "TransId": 0,
  "TransTypeId": 15,
  "TransTypeName": "Journal Entry",
  "PortfolioId": 0,
  "PortfolioName": "",
  "AssetId": 0,
  "AssetName": "",
  "ShareclassId": 0,
  "ShareClassName": "",
  "AssetLotId": 0,
  "AssetLotName": "",
  "TradeStatusId": 2,
  "TradeStatusName": "Executed",
  "TransDate": TransactionDate,
  "TransAmount": 0,
  "CurrencyId": 0,
  "CurrencyCode": "",
  "ExchangeRateId": 0,
  "ExchangeRate": 1,
  "IsFullRedemption": false,
  "IsInsurance": false,
  "IsFee": false,
  "IsCommitmentRelease": false,
  "TransDescription": "",
  "ModifiedById": 0,
  "ModifiedByName": "",
  "ChildDetails": [
    {
      "TransId": 0,
      "TransTypeId": 9,
      "TransTypeName": "Journal Entry",
      "AssetId": 0,
      "AssetName": "",
      "ShareclassId": 0,
      "ShareClassName": "",
      "AssetLotId": 0,
      "AssetLotName": "",
      "TransDate": "",
      "TransAmount": 0,
      "TransDescription": "",
      "ModifiedById": 0,
      "ModifiedByName": ""
    },
    {
      "TransId": 0,
      "TransTypeId": 9,
      "TransTypeName": "Journal Entry",
      "AssetId": 0,
      "AssetName": "",
      "ShareclassId": 0,
      "ShareClassName": "",
      "AssetLotId": 0,
      "AssetLotName": "",
      "TransDate": "",
      "TransAmount": 0,
      "TransDescription": "",
      "ModifiedById": 0,
      "ModifiedByName": ""
    }
  ]
};
const getPositive=(value)=>{
  try{
    if(value>=0)    
    return value;
    else 
    return value*-1;
  }
  catch
  {
    return 0
  }

};
const getPortfolioLedgerAccounts=async(id)=>{
  try {
    const response = await sbaAxios({url:getPortfolioLedgerAccountsAPI+'/'+id});
    return response;
  } 
  catch(e)  {
    return [];
  } 
}